const mixin = {
  data() {
    return {};
  },
  methods: {
    getWhetherMsg(val) {
      console.log('getWhetherMsg', val);
      let arr = { 0: '否', 1: '是' };
      return arr[val];
    },
    getAuditStatusMsg(val) {
      console.log('getAuditStatusMsg', val);
      let arr = { '01': '待提交', '02': '待审核', '03': '审核通过', '04': '审核驳回' };
      return arr[val];
    },
    getEffectiveStatusMsg(val) {
      if (val == null) {
        return '';
      }
      console.log('getEffectiveStatusMsg', val);
      let arr = { '01': '待生效', '02': '生效中', '03': '已失效', '04': '变更中' };
      return arr[val];
    },
    getLeaseStatusMsg(val) {
      if (val == null) {
        return '待出租';
      }
      console.log('getLeaseStatusMsg', val);
      let arr = { '01': '待出租', '02': '已出租' };
      return arr[val] || '待出租';
    },
    getTypeTitle(val) {
      console.log('getTypeTitle', val);
      let arr = {
        '01': '片区信息',
        '02': '资产信息',
        '03': '单元（楼栋）信息',
        '04': '楼层信息',
        '05': '房间信息',
      };
      return arr[val];
    },
    getAssetTypeMsg(val) {
      if (val == null || val == '') {
        return '';
      }
      let arr = {
        '01': '住宅',
        '02': '车位',
        '03': '商铺',
        '04': '车位',
        '05': '广告位',
      };
      let data = val.split(',');
      let tempArr = [];
      data.forEach((element) => {
        tempArr.push(arr[element]);
      });
      return tempArr.join(',');
    },
    resetCondition() {
      this.spaceInfoList = [];
      const handleMap = {
        '02': this.reset02,
        '03': this.reset03,
        '04': this.reset04,
        '05': this.reset05,
      };
      handleMap[this.spaceData.space.type]();
    },
    reset02() {
      this.spaceInfoList.push(
        {
          prop: 'spaceNo',
          name: '资产编号：',
          type: 'input',
          disabled: true,
          placeholder: '',
          span: 12,
        },
        {
          prop: 'name',
          type: 'input',
          name: '资产名称：',
          disabled: true,
          span: 12,
        },
        {
          prop: 'assetTypeMsg',
          type: 'input',
          name: '资产类型：',
          disabled: true,
          span: 12,
        }
      );
      if (this.spaceData.space.leafFlag == 0) {
        this.spaceInfoList.push({
          prop: 'selfUseFlagMsg',
          type: 'input',
          name: '是否自用：',
          disabled: true,
          span: 12,
        });
      }
      this.spaceInfoList.push(
        {
          prop: 'assetLocation',
          type: 'input',
          name: '资产位置：',
          disabled: true,
          span: 12,
        },
        {
          prop: 'selfOwnedFlagMsg',
          type: 'input',
          name: '是否自有：',
          disabled: true,
          span: 12,
        }
      );
      if (this.spaceData.space.selfOwnedFlag == '0') {
        this.spaceInfoList.push({
          prop: 'rightParty',
          type: 'input',
          name: '权利方：',
          disabled: true,
          span: 12,
        });
      }
      this.spaceInfoList.push({
        prop: 'sublevelsMsg',
        type: 'input',
        name: '是否有子层级：',
        disabled: true,
        span: 12,
      });
      if (this.spaceData.space.leafFlag == 0) {
        if (this.spaceData.space.effectiveStatus == '02') {
          this.spaceInfoList.push({
            prop: 'leaseStatusMsg',
            type: 'input',
            name: '租赁状态：',
            disabled: true,
            span: 12,
          });
        }
        this.spaceInfoList.push(
          {
            prop: 'area',
            type: 'inputAmount',
            precision: 2,
            max: 9999999999999,
            name: '面积（㎡）：',
            disabled: true,
            span: 12,
          },
          {
            prop: 'effectiveStatusMsg',
            type: 'input',
            name: '生效状态：',
            disabled: true,
            span: 12,
          },
          {
            prop: 'auditStatusMsg',
            type: 'input',
            name: '审核状态：',
            disabled: true,
            span: 12,
          }
        );
      }
      this.spaceInfoList.push(
        {
          prop: 'attachments',
          type: 'attachment',
          name: '附件：',
          disabled: true,
          span: 24,
        },
        {
          prop: 'createPersonName',
          type: 'input',
          name: '创建人：',
          disabled: true,
          span: 12,
        },
        {
          prop: 'gmtCreate',
          type: 'input',
          name: '创建时间：',
          disabled: true,
          span: 12,
        }
      );
    },
    reset03() {
      this.spaceInfoList.push(
        {
          prop: 'spaceNo',
          name: '单元（楼栋）编号：',
          type: 'input',
          disabled: true,
          placeholder: '',
          span: 12,
        },
        {
          prop: 'name',
          name: '单元（楼栋）名称：',
          type: 'input',
          disabled: true,
          placeholder: '',
          span: 12,
        }
      );
      if (this.spaceData.space.leafFlag == 0) {
        this.spaceInfoList.push({
          prop: 'selfUseFlagMsg',
          type: 'input',
          name: '是否自用：',
          disabled: true,
          span: 12,
        });
      }
      this.spaceInfoList.push({
        prop: 'sublevelsMsg',
        type: 'input',
        name: '是否有子层级：',
        disabled: true,
        span: 12,
      });
      if (this.spaceData.space.leafFlag == 0) {
        if (this.spaceData.space.effectiveStatus == '02') {
          this.spaceInfoList.push({
            prop: 'leaseStatusMsg',
            type: 'input',
            name: '租赁状态：',
            disabled: true,
            span: 12,
          });
        }
        this.spaceInfoList.push(
          {
            prop: 'area',
            type: 'inputAmount',
            precision: 2,
            max: 9999999999999,
            name: '面积（㎡）：',
            disabled: true,
            span: 12,
          },
          {
            prop: 'effectiveStatusMsg',
            type: 'input',
            name: '生效状态：',
            disabled: true,
            span: 12,
          },
          {
            prop: 'auditStatusMsg',
            type: 'input',
            name: '审核状态：',
            disabled: true,
            span: 12,
          }
        );
      }
      this.spaceInfoList.push(
        {
          prop: 'attachments',
          type: 'attachment',
          name: '附件：',
          disabled: true,
          span: 24,
        },
        {
          prop: 'createPersonName',
          type: 'input',
          name: '创建人：',
          disabled: true,
          span: 12,
        },
        {
          prop: 'gmtCreate',
          type: 'input',
          name: '创建时间：',
          disabled: true,
          span: 12,
        }
      );
    },
    reset04() {
      this.spaceInfoList.push(
        {
          prop: 'spaceNo',
          name: '楼层编号：',
          type: 'input',
          disabled: true,
          placeholder: '',
          span: 12,
        },
        {
          prop: 'name',
          name: '楼层名称：',
          type: 'input',
          disabled: true,
          placeholder: '',
          span: 12,
        }
      );
      if (this.spaceData.space.leafFlag == 0) {
        this.spaceInfoList.push({
          prop: 'selfUseFlagMsg',
          type: 'input',
          name: '是否自用：',
          disabled: true,
          span: 12,
        });
      }
      this.spaceInfoList.push({
        prop: 'sublevelsMsg',
        type: 'input',
        name: '是否有子层级：',
        disabled: true,
        span: 12,
      });
      if (this.spaceData.space.leafFlag == 0) {
        if (this.spaceData.space.effectiveStatus == '02') {
          this.spaceInfoList.push({
            prop: 'leaseStatusMsg',
            type: 'input',
            name: '租赁状态：',
            disabled: true,
            span: 12,
          });
        }
        this.spaceInfoList.push(
          {
            prop: 'area',
            type: 'inputAmount',
            precision: 2,
            max: 9999999999999,
            name: '面积（㎡）：',
            disabled: true,
            span: 12,
          },
          {
            prop: 'effectiveStatusMsg',
            type: 'input',
            name: '生效状态：',
            disabled: true,
            span: 12,
          },
          {
            prop: 'auditStatusMsg',
            type: 'input',
            name: '审核状态：',
            disabled: true,
            span: 12,
          }
        );
      }
      this.spaceInfoList.push(
        {
          prop: 'attachments',
          type: 'attachment',
          name: '附件：',
          disabled: true,
          span: 24,
        },
        {
          prop: 'createPersonName',
          type: 'input',
          name: '创建人：',
          disabled: true,
          span: 12,
        },
        {
          prop: 'gmtCreate',
          type: 'input',
          name: '创建时间：',
          disabled: true,
          span: 12,
        }
      );
    },
    reset05() {
      this.spaceInfoList.push(
        {
          prop: 'spaceNo',
          name: '房间编号：',
          type: 'input',
          disabled: true,
          placeholder: '',
          span: 12,
        },
        {
          prop: 'name',
          name: '房间名称：',
          type: 'input',
          disabled: true,
          placeholder: '',
          span: 12,
        },
        {
          prop: 'selfUseFlagMsg',
          type: 'input',
          name: '是否自用：',
          disabled: true,
          span: 12,
        },
        {
          prop: 'area',
          type: 'inputAmount',
          precision: 2,
          max: 9999999999999,
          name: '面积（㎡）：',
          disabled: true,
          span: 12,
        }
      );
      if (this.spaceData.space.leafFlag == 0) {
        if (this.spaceData.space.effectiveStatus == '02') {
          this.spaceInfoList.push({
            prop: 'leaseStatusMsg',
            type: 'input',
            name: '租赁状态：',
            disabled: true,
            span: 12,
          });
        }
        this.spaceInfoList.push(
          {
            prop: 'effectiveStatusMsg',
            type: 'input',
            name: '生效状态：',
            disabled: true,
            span: 12,
          },
          {
            prop: 'auditStatusMsg',
            type: 'input',
            name: '审核状态：',
            disabled: true,
            span: 12,
          }
        );
      }

      this.spaceInfoList.push(
        // {
        //   prop: 'effectiveStatusMsg',
        //   type: 'input',
        //   name: '生效状态：',
        //   disabled: true,
        //   span: 12,
        // },
        // {
        //   prop: 'auditStatusMsg',
        //   type: 'input',
        //   name: '审核状态：',
        //   disabled: true,
        //   span: 12,
        // },
        {
          prop: 'attachments',
          type: 'attachment',
          name: '附件：',
          disabled: true,
          span: 24,
        },
        {
          prop: 'createPersonName',
          type: 'input',
          name: '创建人：',
          disabled: true,
          span: 12,
        },
        {
          prop: 'gmtCreate',
          type: 'input',
          name: '创建时间：',
          disabled: true,
          span: 12,
        }
      );
    },
  },
};
export default mixin;
